module.exports = __webpack_public_path__ + "static/larufa1-28a0afe1b91e67a17b058c4ee32f1ad7.jpg";